import React from 'react';
import { Carousel, CarouselContent, CarouselItem } from './ui/carousel';
import { Card, CardContent } from './ui/card';
import { clientLogos } from '../data/mockData';
import Autoplay from 'embla-carousel-autoplay';

const ClientLogos = () => {
  const plugin = React.useRef(
    Autoplay({ delay: 2500, stopOnInteraction: true, stopOnMouseEnter: true })
  );

  return (
    <section className="py-16 bg-[#37464F]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-[#009688] uppercase tracking-wide mb-2">
            Trusted by Industry Leaders
          </p>
          <p className="text-gray-300 text-lg">
            Powering cashless experiences for events, venues, and hospitality worldwide
          </p>
        </div>

        {/* Logo Carousel */}
        <Carousel
          plugins={[plugin.current]}
          className="w-full"
          opts={{
            align: "start",
            loop: true,
            dragFree: false,
          }}
        >
          <CarouselContent className="-ml-2 md:-ml-4">
            {clientLogos.map((client, index) => (
              <CarouselItem key={index} className="pl-2 md:pl-4 basis-1/2 md:basis-1/3 lg:basis-1/6">
                <Card className="bg-[#edefef] border-gray-300 hover:border-[#009688]/50 transition-all duration-300 hover:shadow-lg hover:shadow-[#009688]/10">
                  <CardContent className="p-6 flex items-center justify-center h-32">
                    <div className="text-center w-full">
                      <div className="w-full h-20 flex items-center justify-center mb-2">
                        <img 
                          src={client.image} 
                          alt={client.name}
                          className="max-w-full max-h-full object-contain"
                        />
                      </div>
                      <p className="text-xs text-gray-600 font-medium truncate">{client.name}</p>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>
            ))}
            {/* Duplicate items for seamless loop */}
            {clientLogos.map((client, index) => (
              <CarouselItem key={`dup-${index}`} className="pl-2 md:pl-4 basis-1/2 md:basis-1/3 lg:basis-1/6">
                <Card className="bg-[#edefef] border-gray-300 hover:border-[#009688]/50 transition-all duration-300 hover:shadow-lg hover:shadow-[#009688]/10">
                  <CardContent className="p-6 flex items-center justify-center h-32">
                    <div className="text-center w-full">
                      <div className="w-full h-20 flex items-center justify-center mb-2">
                        <img 
                          src={client.image} 
                          alt={client.name}
                          className="max-w-full max-h-full object-contain"
                        />
                      </div>
                      <p className="text-xs text-gray-600 font-medium truncate">{client.name}</p>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>

        {/* Carousel Indicators */}
        <div className="flex justify-center mt-8 space-x-2">
          {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="w-2 h-2 rounded-full bg-[#009688] opacity-30 hover:opacity-70 transition-opacity"
            ></div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
